import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Calendar from '@sbmdkl/nepali-datepicker-reactjs';
import '@sbmdkl/nepali-datepicker-reactjs/dist/index.css';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import { alertAction } from '../Redux/Actions/alertAction';
import PhysicalDetailTable from './Common/PhysicalDetailTable';
import MemberDetails from './Common/MemberDetails';

const AddMember = ({ isShow, setIsShow }) => {
    // const [selectedImage, setSelectedImage] = useState();
    const [isValid, setIsValid] = useState(false);
    const [bsDate, setBsDate] = useState(false);
    const [adDate, setAdDate] = useState(true);
    const [isTime, setIsTime] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [isSubmit, setIsSubmit] = useState(false);
    const { slug } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const initialValues = { user: 'guest', date: 'AD', occupation: '', admissionCharge: '', experience: '', name: '', mobile: '', email: '', startingBsDate: '', endingBsDate: '', startingAdDate: '', endingAdDate: '', selectGender: '', selectBlood: '', home: '', birth: '', address: '', memberFee: '', prgFee: '', payable: '', pkgSelect: '', admissionAdDate: '', admissionBsDate: '', fullName: '', district: '', vdc: '', ward: '', tole: '', country: '', cAddress: '', citizenship: '', emergencyName: '', relationship: '', emergencyAddress: '', emergencyNumber: '', totalFee: '', receiveAmt: '', period: '', receiptNo: '', status: '', schedule: '', fromTime: '', tillTime: '' };

    const [formValues, setFormValues] = useState(initialValues);

    // const imageChange = (e) => {
    //     if (e.target.files && e.target.files.length > 0) {
    //         setSelectedImage(e.target.files[0]);
    //     }
    // };

    const handleDate = ({ bsDate, adDate }) => {
        setFormValues({
            ...formValues,
            startingBsDate: bsDate,
            endingBsDate: bsDate,
            admissionBsDate: bsDate
        })
    };

    const handleBsDate = () => {
        setBsDate(true);
        setAdDate(false);
    }

    const handleAdDate = () => {
        setBsDate(false);
        setAdDate(true);
    }

    const TimeRange = () => {
        if (formValues.schedule === '') setIsTime(false);
        else setIsTime(true);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        const { admissionCharge } = formValues;
        if (name === "user" && value === 'valid') setFormValues({ ...formValues, status: 'New', [name]: value });

        else if (name === "user" && value === 'guest') setFormValues({ ...formValues, status: '', [name]: value });

        else if (name === 'period' || name === 'pkgSelect') getValues(value, formValues, setFormValues, name, isValid, admissionCharge)

        else setFormValues({
            ...formValues,
            [name]: value
        })


    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormErrors(validate(formValues));
        setIsSubmit(true);
        console.log(formValues);
    };

    useEffect(() => {
        if (Object.keys(formErrors).length === 0 && isSubmit) {
            navigate('/admin/members/all');
            dispatch(alertAction());
            setIsSubmit(false);
        }
    }, [isSubmit, formErrors, dispatch, navigate])

    const validate = (values) => {
        const errors = {};
        const regex = /^([_\-\.a-zA-z]+)@([_\-\.a-zA-Z0-9]+)\.([a-zA-Z]){2,7}$/i;
        return validation(values, errors, regex, isValid);
    };

    useEffect(() => {
        if (slug) {
            setFormValues({ occupation: '', experience: 'Yes', name: 'Shila', mobile: '9845056786', email: 'example@gmail.com', startingAdDate: '2022-03-14', endingAdDate: '2022-03-14', selectGender: 'Female', selectBlood: 'Unmarried', home: '', birth: '', address: '', memberFee: '100', prgFee: '3000', payable: '', pkgSelect: 'Weight Loss', admissionCharge: '', admissionAdDate: '', fullName: '', district: '', vdc: '', ward: '', tole: '', country: '', cAddress: '', citizenship: '', emergencyName: '', relationship: '', emergencyAddress: '', emergencyNumber: '', totalFee: '', receiveAmt: '', period: '', receiptNo: '' })
        }
    }, [slug])


    return (
        <div className='page_first_div'>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='page_sec_div '>
                <p className='page_topic inline-block'>{`${slug ? "Edit" : "Add"} Member`}</p>
                <div className='inline-block bg-cyan-600 px-3 py-1 ml-2 rounded-md hover:bg-cyan-700 animation'>
                    <Link to="/admin/members/all" className='link block text-white text-sm'>
                        <i className="fa-solid fa-arrow-left mr-1"></i>
                        All
                    </Link>
                </div>
                <section className='page_section px-4 xsm:px-8 py-2 min-h-[25rem]'>
                    <form action="" onSubmit={handleSubmit}>

                        {/* MEMBER TYPE AND DATE TYPE START*/}
                        <div className='grid gap-4 lg:grid-cols-2 lg:gap-6 pt-5'>
                            <div className='font-lato'>
                                <h3 className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Member Type<span className='text-red-500 tracking-wide'>&#42;</span></h3>
                                <div className='float-left mr-4 pt-2'>
                                    <input type="radio" id='guest' value='guest' onChange={handleChange} name='user' className='cursor-pointer' onClick={() => setIsValid(false)} required checked={isValid === false} />
                                    <label htmlFor="guest" className='text-gray-800 font-semibold text-xs xsm:text-sm ml-1 cursor-pointer'>Guest Member</label>
                                </div>
                                <div className='pt-2'>
                                    <input type="radio" id='valid' value='valid' name='user' className='cursor-pointer' required onClick={() => setIsValid(true)} onChange={handleChange} />
                                    <label htmlFor="valid" className={`text-gray-800 font-semibold text-xs xsm:text-sm ml-1 cursor-pointer `}>Valid Member</label>
                                </div>
                            </div>

                            <div className='font-lato'>
                                <h3 className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Date Type<span className='text-red-500 tracking-wide'>&#42;</span></h3>
                                <div className='float-left mr-4 pt-2'>
                                    <input type="radio" id='adDate' value='adDate' onChange={handleChange} onClick={handleAdDate} name='date' className='cursor-pointer' required checked={bsDate === false} />
                                    <label htmlFor="adDate" className='text-gray-800 font-semibold text-xs xsm:text-sm ml-1 cursor-pointer'>AD</label>
                                </div>
                                <div className='pt-2'>
                                    <input type="radio" id='bsDate' value='bsDate' name='date' className='cursor-pointer' required onChange={handleChange} onClick={handleBsDate} />
                                    <label htmlFor="bsDate" className={`text-gray-800 font-semibold text-xs xsm:text-sm ml-1 cursor-pointer `}>BS</label>
                                </div>
                            </div>
                        </div>

                        {/* admission form start */}
                        {isValid &&
                            <>
                                <div className='md:px-36 lg:px-52 xl:px-96 pt-6'>
                                    <h2 className='text-center text-white rounded font-bold text-sm lg:text-xl underline p-4 bg-blue-900'>ADMISSION FORM</h2>
                                </div>
                                <div className='grid gap-4 lg:grid-cols-2 lg:gap-6 pt-5'>
                                    <div className='font-lato text-sm xsm:text-base '>
                                        <p className='text-gray-800 font-semibold tracking-wider '>Name<span className='text-red-500 tracking-wide'>&#42;</span>
                                        </p>
                                        <input type="text" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide Name' name='name' value={formValues.name} onChange={handleChange} />
                                        <small className='text-red-500 tracking-wide'>{formErrors.name}</small>
                                    </div>
                                    <div className='font-lato text-sm xsm:text-base '>
                                        <p className='text-gray-800 font-semibold tracking-wider '>Address<span className='text-red-500 tracking-wide'>&#42;</span></p>
                                        <textarea className='pl-4 pt-2 text-gray-800 text-sm h-16  w-full outline-none border-2 rounded placeholder:text-xs xsm:placeholder:text-sm' placeholder='Address...' name='address' value={formValues.address} onChange={handleChange}></textarea>
                                        <small className='text-red-500 tracking-wide'>{formErrors.address}</small>
                                    </div>
                                    {/* ENGLISH DATE */}
                                    {adDate && <div className='font-lato text-sm xsm:text-base '>
                                        <p className='text-gray-800 font-semibold tracking-wider '> Date of Birth</p>
                                        <input type="date" className='form_input_date border-2 h-10 w-full' name='birth' value={formValues.birth} onChange={handleChange} />
                                    </div>}

                                    {/* NEPALI DATE */}

                                    {bsDate && <div className='font-lato text-sm xsm:text-base '>
                                        <p className='text-gray-800 font-semibold tracking-wider '> Date of Birth</p>
                                        <Calendar onChange={handleDate} dateFormat='YYYY-MM-DD' language='en' placeholder="Select Date" className="form_input_date border-2 h-10 w-full rounded-sm" />
                                    </div>}
                                    <div className='font-lato text-sm xsm:text-base'>
                                        <p className='text-gray-800 font-semibold tracking-wider '>Occupation<span className='text-red-500 tracking-wide'>&#42;</span>
                                        </p>
                                        <input type="text" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide Your Occupation' name='occupation' value={formValues.occupation} onChange={handleChange} />
                                        <small className='text-red-500 tracking-wide'>{formErrors.occupation}</small>
                                    </div>
                                    <div className='font-lato text-sm xsm:text-base '>
                                        <p className='text-gray-800 font-semibold tracking-wider'>Telephone Home</p>
                                        <div className='form_div'>
                                            <input type="tel" className='form_input_icon' placeholder='Telephone Number' name='home' value={formValues.home} onChange={handleChange} />
                                            <p className='form_icon_para'>
                                                <i className="fa-solid fa-phone"></i>
                                            </p>
                                        </div>
                                    </div>
                                    <div className='font-lato text-sm xsm:text-base '>
                                        <p className='text-gray-800 font-semibold tracking-wider'>Mobile <span className='text-red-500 tracking-wide'>&#42;</span></p>
                                        <div className='form_div'>
                                            <input type="text" className='form_input_icon' placeholder='Please Provide Mobile Number' name='mobile' value={formValues.mobile} onChange={handleChange} />
                                            <p className='form_icon_para'>
                                                <i className="fa-solid fa-mobile-screen-button"></i>
                                            </p>
                                        </div>
                                        <small className='text-red-500 tracking-wide'>{formErrors.mobile}</small>
                                    </div>
                                    <div className='font-lato '>
                                        <p className='text-gray-800 text-sm sm:text-base font-semibold tracking-wider'>Gender<span className='text-red-500 tracking-wide'>&#42;</span></p>
                                        <select className="selector" name='selectGender' value={formValues.selectGender} onChange={handleChange}>
                                            <option value=''>--Select Gender--</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Transgender">Transgender</option>
                                            <option value="Other">Other</option>
                                        </select>
                                        <small className='text-red-500 tracking-wide'>{formErrors.selectGender}</small>
                                    </div>
                                    <div className='font-lato '>
                                        <p className='text-gray-800 text-sm sm:text-base font-semibold tracking-wider'>Blood Group<span className='text-red-500 tracking-wide'>&#42;</span></p>
                                        <select className="selector" name='selectBlood' value={formValues.selectBlood} onChange={handleChange}>
                                            <option value=''>--Select Blood Group--</option>
                                            <option value="+AB">+AB</option>
                                            <option value="-AB">-AB</option>
                                            <option value="+O">+O</option>
                                            <option value="-O">-O</option>
                                            <option value="+B">+B</option>
                                            <option value="-B">-B</option>
                                            <option value="+A">+A</option>
                                            <option value="-A">-A</option>
                                        </select>
                                        <small className='text-red-500 tracking-wide'>{formErrors.selectBlood}</small>
                                    </div>
                                    <div className='font-lato text-sm xsm:text-base '>
                                        <p className='text-gray-800 font-semibold tracking-wider'>Email<span className='text-red-500 tracking-wide'>&#42;</span></p>
                                        <div className='form_div'>
                                            <input type="text" className='form_input_icon' placeholder='Please provide Email' name='email' value={formValues.email} onChange={handleChange} />
                                            <p className='form_icon_para'>
                                                <i className="fa-regular fa-envelope"></i>
                                            </p>
                                        </div>
                                        <small className='text-red-500 tracking-wide'>{formErrors.email}</small>
                                    </div>
                                    <div className='font-lato '>
                                        <p className='text-gray-800 text-sm sm:text-base font-semibold tracking-wider'>Experience in GYM</p>
                                        <select className="selector" name='experience' value={formValues.experience} onChange={handleChange}>
                                            <option value="">--Select your GYM Experience--</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                    </div>
                                    <div className='font-lato '>
                                        <p className='text-gray-800 text-sm sm:text-base font-semibold tracking-wider'>Refer By</p>
                                        <select className="selector" name='experience' value={formValues.experience} onChange={handleChange}>
                                            <option value="">--Select Refer by--</option>
                                            <option value="Social Media">Social Media</option>
                                            <option value="Friends">Friends</option>
                                            <option value="Others">Others</option>
                                        </select>
                                    </div>

                                    {/* ENGLISH DATE */}
                                    {adDate && <div className='font-lato text-sm xsm:text-base '>
                                        <p className='text-gray-800 font-semibold tracking-wider '>Admission Date<span className='text-red-500 tracking-wide'>&#42;</span></p>
                                        <input type="date" className='form_input_date border-2 h-10 w-full' name='admissionAdDate' value={formValues.admissionDate} onChange={handleChange} />
                                        <small className="text-red-500 tracking-wide">{formErrors.admissionDate}</small>
                                    </div>}

                                    {/* NEPALI DATE */}
                                    {bsDate && <div className='font-lato text-sm xsm:text-base '>
                                        <p className='text-gray-800 font-semibold tracking-wider '>Admission Date<span className='text-red-500 tracking-wide'>&#42;</span></p>
                                        <Calendar onChange={handleDate} dateFormat='YYYY-MM-DD' language='en' name='admissionBsDate' placeholder="Select" className="form_input_date border-2 h-10 w-full rounded-sm" />
                                    </div>}
                                    <div className='font-lato text-sm xsm:text-base '>
                                        <p className='text-gray-800 font-semibold tracking-wider'>Admission Charge<span className='text-red-500'>&#42;</span></p>
                                        <div className='flex justify-center items-baseline h-10 w-full border-2 text-gray-700 outline-gray-300 rounded'>
                                            <p className='h-full text-center flex-1 px-1 sm:px-0'>Rs.</p>
                                            <input type="text" className='placeholder:text-sm placeholder:text-gray-700 flex-[9] outline-none h-full pr-6 border-l-2 pl-2 text-sm' name='admissionCharge' value={formValues.admissionCharge} onChange={handleChange} />
                                        </div>
                                        <small className="text-red-500 tracking-wide">{formErrors.admissionCharge}</small>
                                    </div>
                                </div>
                            </>
                        }

                        {/* Physical Details start */}
                        <div>
                            <div className='md:px-36 lg:px-52 xl:px-96'>
                                <h3 className='text-center text-white mt-6 rounded font-bold text-sm lg:text-xl underline p-4 bg-blue-900'>PHYSICAL DETAILS</h3>
                            </div>
                            <PhysicalDetailTable />
                        </div>

                        {/* Choose File opion*/}
                        {/* <div className='mt-10'>
                            <h3 className='text-gray-800 font-semibold tracking-wide text-sm xsm:text-base'>Photo Upload</h3>
                            <input type="file" className='cursor-pointer text-gray-800 w-full text-sm lg:text-base break-all' onChange={imageChange} accept="image/*" />
                            <div className='py-4'>
                                {selectedImage ? <img src={URL.createObjectURL(selectedImage)} alt="" className='h-20 w-16 xsm:h-24 xsm:w-20 object-cover rounded' /> : <i className="fa-solid fa-file-image text-6xl xsm:text-8xl text-blue-500"></i>}
                            </div>
                        </div> */}

                        {/* MEMBER DETAILS START */}
                        <MemberDetails
                            formValues={formValues}
                            formErrors={formErrors}
                            handleChange={handleChange}
                        />

                        {/* Package Details start */}
                        <>
                            <div className='md:px-36 lg:px-52 xl:px-96'>
                                <h3 className='text-center text-white rounded font-bold my-6 text-sm lg:text-xl underline p-4 bg-blue-900'>PACKAGE DETAILS</h3>
                            </div>
                            <div className='grid gap-4 lg:grid-cols-2 lg:gap-6'>
                                <div className='font-lato '>
                                    <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Package Type<span className='text-red-500 tracking-wide'>&#42;</span></p>
                                    <select className="selector" name='pkgSelect' value={formValues.pkgSelect} onChange={handleChange}>
                                        <option value='' >--Select Package--</option>
                                        <option value="Basic">Basic(Gym & Cardio)</option>
                                        <option value="Zumba">{isValid ? "Zumba(with Gym & Cardio)" : "Zumba"}</option>
                                    </select>
                                    <small className='text-red-500 tracking-wide'>{formErrors.pkgSelect}</small>
                                </div>
                                <div className='font-lato '>
                                    <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Package Period<span className='text-red-500 tracking-wide'>&#42;</span></p>
                                    <select className="selector" name='period' value={formValues.period} onChange={handleChange}>
                                        <option value='' >--Select Period--</option>
                                        <option value={isValid ? "1 Month" : "Per Day"}>{isValid ? "1 Month" : "Per Day"}</option>
                                        <option value={isValid ? "3 Months" : "Per Week"}>{isValid ? "3 Months" : "Per Week"}</option>
                                        <option value={isValid ? "6 Months" : "Per Month"}>{isValid ? "6 Months" : "Per Month"}</option>
                                        {isValid && <option value="1 year">1 year</option>}
                                    </select>
                                    <small className='text-red-500 tracking-wide'>{formErrors.period}</small>
                                </div>
                                <div className='font-lato '>
                                    <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Convinient Time<span className='text-red-500 tracking-wide'>&#42;</span></p>
                                    <select className="selector" name='schedule' value={formValues.schedule} onChange={handleChange} onClick={TimeRange}>
                                        <option value='' >--Select Schedule--</option>
                                        <option value="Morning">Morning</option>
                                        <option value="Day">Day</option>
                                        <option value="Evening">Evening</option>
                                    </select>
                                    <small className='text-red-500 tracking-wide'>{formErrors.schedule}</small>
                                    {isTime &&
                                        <div className='mt-2'>
                                            <input type="time" name='fromTime' className='outline-none border-b-2 border-dashed border-black h-9 text-sm pl-2 ' value={formValues.fromTime} onChange={handleChange} />
                                            <label htmlFor="" className='mx-3 font-semibold'>To</label>
                                            <input type="time" name='tillTime' className='outline-none border-b-2 border-dashed border-black h-9 text-sm pl-2 ' value={formValues.tillTime} onChange={handleChange} />
                                        </div>
                                    }
                                </div>
                                <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider'>Total Fee</p>
                                    <div className='flex justify-center items-baseline h-10 w-full border-2 text-gray-700 outline-gray-300 rounded'>
                                        <p className='h-full text-center flex-1 px-1 sm:px-0'>Rs.</p>
                                        <input type="text" className='placeholder:text-sm placeholder:text-gray-700 flex-[9] outline-none h-full pr-6 border-l-2 pl-2 text-sm' name='totalFee'
                                            value={isValid ? Number(formValues.totalFee) + Number(formValues.admissionCharge) : formValues.totalFee}
                                            onChange={handleChange} disabled />
                                    </div>
                                </div>
                                <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider'>Received admissionCharge<span className='text-red-500 tracking-wide'>&#42;</span></p>
                                    <div className='flex justify-center items-baseline h-10 w-full border-2 text-gray-700 outline-gray-300 rounded'>
                                        <p className='h-full text-center flex-1 px-1 sm:px-0'>Rs.</p>
                                        <input type="number" className='placeholder:text-sm placeholder:text-gray-700 flex-[9] outline-none h-full pr-6 border-l-2 pl-2 text-sm' name='receiveAmt'
                                            value={formValues.receiveAmt}
                                            onChange={handleChange} />
                                    </div>
                                    <small className='text-red-500 tracking-wide'>{formErrors.receiveAmt}</small>
                                </div>
                                <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider'>Due admissionCharge</p>
                                    <div className='flex justify-center items-baseline h-10 w-full border-2 text-gray-700 outline-gray-300 rounded'>
                                        <p className='h-full text-center flex-1 px-1 sm:px-0'>Rs.</p>
                                        <input type="number" className='placeholder:text-sm placeholder:text-gray-700 flex-[9] outline-none h-full pr-6 border-l-2 pl-2 text-sm' name='due'
                                            value={isValid ? Number(formValues.totalFee) + Number(formValues.admissionCharge) - formValues.receiveAmt : formValues.totalFee - formValues.receiveAmt}
                                            onChange={handleChange} disabled />
                                    </div>
                                </div>
                                <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider'>Receipt Number<span className='text-red-500 tracking-wide'>&#42;</span></p>
                                    <input type="text" className='form_input border-2 h-10 w-full' name='receiptNo' value={formValues.receiptNo} onChange={handleChange} />
                                    <small className='text-red-500 tracking-wide'>{formErrors.receiptNo}</small>
                                </div>
                            </div>
                        </>

                        {/* Date Criteria start */}
                        <>
                            <div className='md:px-36 lg:px-52 xl:px-96'>
                                <h3 className='text-center text-white rounded font-bold my-6 text-sm lg:text-xl underline p-4 bg-blue-900'>DATE CRITERIA</h3>
                            </div>
                            <div className='grid gap-4 lg:grid-cols-2 lg:gap-6'>
                                {adDate && <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider '>Starting Date<span className='text-red-500 tracking-wide'>&#42;</span>
                                    </p>
                                    <input type="date" className='form_input_date border-2 h-10 w-full' name='startingAdDate' value={formValues.startingAdDate} onChange={handleChange} />
                                    <small className='text-red-500 tracking-wide'>{formErrors.startingAdDate}</small>
                                </div>}
                                {bsDate && <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider '>Starting Date<span className='text-red-500 tracking-wide'>&#42;</span></p>
                                    <Calendar onChange={handleDate} dateFormat='YYYY-MM-DD' language='en' name="startingAdDate" placeholder="Select Date" className="form_input_date border-2 h-10 w-full rounded-sm" />
                                </div>}

                                {adDate && <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider '>Expiry Date<span className='text-red-500 tracking-wide'>&#42;</span>
                                    </p>
                                    <input type="date" className='form_input_date border-2 h-10 w-full' name='endingAdDate' value={formValues.endingAdDate} onChange={handleChange} />
                                    <small className='text-red-500 tracking-wide'>{formErrors.endingAdDate}</small>
                                </div>}
                                {bsDate && <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider '>Expiry Date<span className='text-red-500 tracking-wide'>&#42;</span></p>
                                    <Calendar onChange={handleDate} dateFormat='YYYY-MM-DD' language='en' name="endingAdDate" placeholder="Select Date" className="form_input_date border-2 h-10 w-full rounded-sm" />
                                </div>}
                                <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider'>Status</p>
                                    <input type="text" className='form_input border-2 h-10 w-full' name='status' value={formValues.status} onChange={handleChange} disabled />
                                </div>
                                {/* <div className='font-lato '>
                                    <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Status</p>
                                    <select className="selector" name='status' value={formValues.status} onChange={handleChange} disabled={isValid === false}>
                                        <option value='' selected={isValid === false}>--Select Status--</option>
                                        <option value="New" selected={isValid === true}>New</option>
                                    </select>
                                </div> */}
                            </div>
                        </>

                        {/* Save Reset buttons */}
                        <div className='pt-4 lg:pt-10'>
                            <button className='button mr-2' type='submit'>{`${slug ? "Update" : "Save"}`}</button>
                            <button className='button2' type='reset' onClick={() => setFormValues(initialValues)} >Reset</button>
                        </div>

                    </form>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default AddMember;

const getValues = (value, formValues, setFormValues, name, isValid, admissionCharge) => {
    if (name === 'period') {
        if (formValues.pkgSelect === 'Basic') {
            if (value === 'Per Day' || value === '1 Month') {
                setFormValues({ ...formValues, totalFee: `${isValid ? 1500 : 200}`, [name]: value });
            } else if (value === 'Per Week' || value === '3 Months') {
                setFormValues({ ...formValues, totalFee: `${isValid ? 4000 : 750}`, [name]: value })
            } else if (value === 'Per Month' || value === '6 Months') {
                setFormValues({ ...formValues, totalFee: ` ${isValid ? 7500 : 2000}`, [name]: value })
            } else if (isValid) {
                setFormValues({ ...formValues, totalFee: 13500, [name]: value })
            }
        } else if (formValues.pkgSelect === 'Zumba') {
            if (value === 'Per Day' || value === '1 Month') {
                setFormValues({ ...formValues, totalFee: `${isValid ? 2000 : 250}`, [name]: value })
            } else if (value === 'Per Week' || value === '3 Months') {
                setFormValues({ ...formValues, totalFee: `${isValid ? 5500 : 1000}`, [name]: value })
            } else if (value === 'Per Month' || value === '6 Months') {
                setFormValues({ ...formValues, totalFee: `${isValid ? 10000 : 2500}`, [name]: value })
            } else if (isValid) {
                setFormValues({ ...formValues, totalFee: 18000, [name]: value })
            }
        } else {
            setFormValues({ ...formValues, [name]: value })
        }
    } else if (name === 'pkgSelect') {
        if (formValues.period === 'Per Day' || formValues.period === '1 Month') {
            if (value === 'Basic') {
                setFormValues({ ...formValues, totalFee: `${isValid ? 1500 : 200}`, [name]: value })
            } else if (value === 'Zumba') {
                setFormValues({ ...formValues, totalFee: `${isValid ? 2000 : 250}`, [name]: value })
            }
        } else if (formValues.period === 'Per Week' || formValues.period === '3 Months') {
            if (value === 'Basic') {
                setFormValues({ ...formValues, totalFee: `${isValid ? 4000 : 750}`, [name]: value })
            } else if (value === 'Zumba') {
                setFormValues({ ...formValues, totalFee: `${isValid ? 5500 : 1000}`, [name]: value })
            }
        } else if (formValues.period === 'Per Month' || formValues.period === '6 Months') {
            if (value === 'Basic') {
                setFormValues({ ...formValues, totalFee: `${isValid ? 7500 : 2000}`, [name]: value })
            } else if (value === 'Zumba') {
                setFormValues({ ...formValues, totalFee: `${isValid ? 10000 : 2500}`, [name]: value })
            }
        } else if (formValues.period === '1 year') {
            if (value === 'Basic') {
                setFormValues({ ...formValues, totalFee: 13500, [name]: value })
            } else if (value === 'Zumba') {
                setFormValues({ ...formValues, totalFee: 18000, [name]: value })
            }
        } else {
            setFormValues({ ...formValues, [name]: value })
        }
    }

}

function validation(values, errors, regex, isValid) {
    if (!values.name && isValid) errors.name = "This field is mandatory!";

    if (!values.address && isValid) errors.address = "This field is mandatory!";

    if (!values.admissionDate && isValid) errors.admissionDate = "This field is mandatory!";

    if (!values.occupation && isValid) errors.occupation = "This field is mandatory!";

    if (!values.admissionCharge && isValid) errors.admissionCharge = "This field is mandatory!";

    if (!values.selectGender && isValid) errors.selectGender = "Gender must be selected!";

    if (!values.selectBlood && isValid) errors.selectBlood = "Blood Group must be selected!";

    if (!values.pkgSelect) errors.pkgSelect = "Package must be selected!";

    if (!values.period) errors.period = "Period must be selected!";

    if (!values.schedule) errors.schedule = "Schedule must be selected!";

    if (!values.mobile && isValid) errors.mobile = "Please provide a mobile number!";

    if (!values.startingAdDate) errors.startingAdDate = "Starting date is mandatory!";

    if (!values.endingAdDate) errors.endingAdDate = "Expiry date is mandatory!";

    if (!values.email && isValid) errors.email = "Email is required!";

    else if (!regex.test(values.email) && isValid) errors.email = "This is not a valid email!";

    if (!values.fullName) errors.fullName = "This field is mandatory!";

    if (!values.district) errors.district = "This field is mandatory!";

    if (!values.vdc) errors.vdc = "This field is mandatory!";

    if (!values.ward) errors.ward = "This field is mandatory!";

    if (!values.tole) errors.tole = "This field is mandatory!";

    if (!values.country) errors.country = "This field is mandatory!";

    if (!values.cAddress) errors.cAddress = "This field is mandatory!";

    if (!values.citizenship) errors.citizenship = "This field is mandatory!";

    if (!values.emergencyName) errors.emergencyName = "This field is mandatory!";

    if (!values.relationship) errors.relationship = "This field is mandatory!";

    if (!values.emergencyAddress) errors.emergencyAddress = "This field is mandatory!";

    if (!values.emergencyNumber) errors.emergencyNumber = "This field is mandatory!";

    if (!values.receiveAmt) errors.receiveAmt = "This field is mandatory!";

    if (!values.receiptNo) errors.receiptNo = "This field is mandatory!";

    return errors;
}
